// extracted by mini-css-extract-plugin
export default {"withGrid":"styles__withGrid___Z3-Ck","withoutGrid":"styles__withoutGrid___iMzKV"};